var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpSizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-caret-down 1",
    clipPath: "url(#clip0_6068_4865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 12.5C4.81331 12.5 3.65328 12.1481 2.66658 11.4888C1.67989 10.8295 0.910851 9.89246 0.456726 8.7961C0.00259972 7.69974 -0.11622 6.49334 0.115291 5.32946C0.346802 4.16557 0.918247 3.09647 1.75736 2.25736C2.59648 1.41824 3.66558 0.8468 4.82946 0.615289C5.99335 0.383778 7.19975 0.502598 8.2961 0.956723C9.39246 1.41085 10.3295 2.17988 10.9888 3.16658C11.6481 4.15327 12 5.31331 12 6.5C12 8.0913 11.3679 9.61742 10.2426 10.7426C9.11742 11.8679 7.5913 12.5 6 12.5ZM8.7 7.1L6.2 3.767C6.17684 3.73577 6.14669 3.7104 6.11196 3.69291C6.07723 3.67543 6.03889 3.66633 6 3.66633C5.96112 3.66633 5.92278 3.67543 5.88805 3.69291C5.85332 3.7104 5.82316 3.73577 5.8 3.767L3.3 7.1C3.27215 7.13714 3.25518 7.18131 3.25101 7.22755C3.24684 7.27379 3.25563 7.32028 3.2764 7.3618C3.29716 7.40333 3.32908 7.43825 3.36857 7.46266C3.40806 7.48707 3.45357 7.5 3.5 7.5H8.5C8.54643 7.5 8.59194 7.48707 8.63144 7.46266C8.67093 7.43825 8.70285 7.40333 8.72361 7.3618C8.74437 7.32028 8.75316 7.27379 8.74899 7.22755C8.74482 7.18131 8.72786 7.13714 8.7 7.1Z",
    fill: "#D01A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6068_4865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSizeIcon);
export default __webpack_public_path__ + "static/media/upSizeIcon.9540eb0a3584b9dffd94294f3ab1bbae.svg";
export { ForwardRef as ReactComponent };